import React from 'react';
import {useState, useEffect} from 'react';
import SubPage from './SubPage';
import '../css/page.css'

export default function HomePage(){
    const [page, setPage] = useState("");

    useEffect(() => {
        const urlParams = new URLSearchParams(window.location.search);
        // const langCode = urlParams.get('langcode')?.toLowerCase();
        const tab = urlParams.get('page')?.toLowerCase();
        setPage(tab)
    }, []);

    return (
        <>
            {
                (page!="")
                ?
                <>
                    <SubPage page={page}/>
                </>
                :
                null
            }
        </>
    );
};